import { MenuOptionType } from "@dexteel/mesf-core";
import DescriptionIcon from "@mui/icons-material/Description";
import MemoryIcon from "@mui/icons-material/Memory";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { useNavigate } from "react-router-dom";
import { ProductionDataRow } from "../../models/ProductionDataModel";

type Props = {
	onDeclareClick: (processId: number, ladleClose?: Date | null) => void;
};

export const useProductionOptionsFunctions = ({ onDeclareClick }: Props) => {
	const navigate = useNavigate();

	const goToCasterDataEntry = (processId: number) => {
		navigate(`/caster-data-entry/${processId}`);
	};

	const goToHeatReport = (heatId: number) => {
		navigate(`/heat-report/${heatId}/caster`);
	};

	const getMenuOptions = (data: ProductionDataRow | null) => {
		const options: MenuOptionType[] = [];

		if (!data) {
			return options;
		}
		options.push({
			name: data.Declared ? "Re-declare" : "Declare",
			key: "declare_product_batch",
			style: { fontWeight: "bold" },
			onClick: () => onDeclareClick(data.ProcessId, data.LadleClose),
			icon: <ReceiptIcon />,
		});
		options.push({
			name: "See in Data Entry",
			key: "go_to_caster_data_entry",
			onClick: () => goToCasterDataEntry(data.ProcessId),
			icon: <MemoryIcon />,
		});
		options.push({
			name: "See in Heat Report",
			key: "go_to_heat_report",
			onClick: () => goToHeatReport(data.HeatId),
			icon: <DescriptionIcon />,
		});

		return options;
	};

	return {
		getMenuOptions,
		goToCasterDataEntry,
		goToHeatReport,
	};
};
